var map = {
	"./busd.svg": 2081,
	"./crypto-pending.png": 2082,
	"./crypto-reject.png": 2083,
	"./crypto-success.png": 2084,
	"./direpay.svg": 2085,
	"./trx.svg": 2086,
	"./usdc.svg": 2087,
	"./usdt.svg": 2088
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 153;